export default __webpack_public_path__ + "media/Number7.090808497c19560e4ad592224744c6c9.mp4";